import { render, staticRenderFns } from "./ChangeDeliveryStateMasiveModal.vue?vue&type=template&id=b2049cf2&lang=pug&"
import script from "./ChangeDeliveryStateMasiveModal.vue?vue&type=script&lang=js&"
export * from "./ChangeDeliveryStateMasiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports